import SpriteSymbol from "../../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "credit-card",
  "use": "credit-card-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 24 24\" id=\"credit-card\">\n<path d=\"M21,21H3c-1.7,0-3-1.3-3-3V6c0-1.7,1.3-3,3-3h18c1.7,0,3,1.3,3,3v12C24,19.7,22.7,21,21,21z M3,5C2.4,5,2,5.4,2,6v12\n\tc0,0.6,0.4,1,1,1h18c0.6,0,1-0.4,1-1V6c0-0.6-0.4-1-1-1H3z\" />\n<path d=\"M23,11H1c-0.6,0-1-0.4-1-1s0.4-1,1-1h22c0.6,0,1,0.4,1,1S23.6,11,23,11z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol